export const WarnIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
    >
      <path
        d="M1.25 26.75H28.75L15 3L1.25 26.75ZM16.25 23H13.75V20.5H16.25V23ZM16.25 18H13.75V13H16.25V18Z"
        fill="#E59401"
      />
    </svg>
  );
};
